import { FC } from 'react';
import { Banner, BannerVariant } from 'components/Banner';
import { MerchantCurrency } from 'components/MerchantCurrency';
import Typography from 'components/Typography/Typography';
import { Trans, useTranslation } from 'react-i18next';
import { Button, ButtonVariant } from '@clover/web-lib-consumer-ui';
import { BELOW_FREE_DELIVERY_INFO_TEST_ID } from 'components/BelowFreeDeliveryInfo.const';
import { useDeliveryPlacementConditions } from 'hooks/useDeliveryPlacementConditions';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { useServiceType } from 'hooks/context/serviceType';

type BelowFreeDeliveryInfoProps = {
  className?: string;
  onAddMoreClick?: () => void;
};

export const BelowFreeDeliveryInfo: FC<BelowFreeDeliveryInfoProps> = ({ className, onAddMoreClick }) => {
  const { t } = useTranslation();
  const navigate = useSmartNavigate();
  const { amountLeftForFreeDelivery, isBelowFreeDelivery, isBelowMinimumDeliveryAmount } =
    useDeliveryPlacementConditions();
  const { isDelivery } = useServiceType();
  const onAddMoreClickFn = onAddMoreClick ?? (() => navigate('~'));

  return (
    <>
      {isDelivery && !isBelowMinimumDeliveryAmount && isBelowFreeDelivery && (
        <Banner
          variant={BannerVariant.INFO}
          className={className}
          rounded={true}
          aria-live={'polite'}
          data-testid={BELOW_FREE_DELIVERY_INFO_TEST_ID.belowFree}
        >
          <Typography.Body bold>
            <Trans i18nKey="deliveryBanner.freeDelivery">
              You're <MerchantCurrency tagName="span" amount={amountLeftForFreeDelivery} /> away from free delivery!
            </Trans>
          </Typography.Body>

          <Typography.Body>
            <Button
              data-testid={BELOW_FREE_DELIVERY_INFO_TEST_ID.addMore}
              variant={ButtonVariant.TEXT_LINK}
              onClick={onAddMoreClickFn}
            >
              <Typography.Body>{t('deliveryBanner.addMore')}</Typography.Body>
            </Button>
            {t('deliveryBanner.toRemove')}
          </Typography.Body>
        </Banner>
      )}
    </>
  );
};
